<template>
  <div class="welfareqrcode">
    <div class="card">
      <div class="cardName">卡卷信息</div>
      <div class="cardNumAndState clearfix">
        <div class="cardNum">卷码：{{ this.welfareqrcode.code }}</div>
        <div class="noUsedStatus" v-if="this.welfareqrcode.status == 1">
          未使用
        </div>
        <div class="usedStatus" v-else>已使用</div>
      </div>
      <!-- <div class="name">{{ this.welfareqrcode.title }}</div> -->
    </div>
    <div class="btnDiv" v-if="this.welfareqrcode.status == 1">
      <button class="btn" @click="writeOff">立即核销</button>
    </div>
    <div class="useData" v-if="this.welfareqrcode.status !== 1">
      <div class="useDataName">使用信息</div>
      <div class="usedDate">核销时间：{{ this.welfareqrcode.hexiaoAt }}</div>
      <div class="usedPerson">核销人员：{{ this.welfareqrcode.hexiaoName }}</div>
    </div>
    <div class="tips" v-if="this.welfareqrcode.status !== 1">该卡卷已使用</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      welfareqrcode: "",
    };
  },
  created() {
    this.getWelfareqrcode();
  },
  methods: {
    async getWelfareqrcode() {
      const result = await this.$http.get("/alumniCard/getWelfareLog", {
        params: {
          wId: this.$route.query.wId,
          userId: this.$route.query.userId,
        },
      });
      this.welfareqrcode = result.data;
    },
    async writeOff() {
      const result = await this.$http({
        url: "/alumniCard/changeQrCodeStatus?" + 'userId=' + this.$route.query.userId + '&wId=' + this.$route.query.wId + '&status=2' + '&hexiaoName=' + encodeURI(window.localStorage.getItem('writeOffName')),
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
      /*   data: {
          userId: this.$route.query.userId,
          wId: this.$route.query.wId,
          status: 2,
          hexiaoName: window.localStorage.getItem('writeOffName')
        }, */
      });
      if (result.data == true) {
        this.$toast("核销成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.welfareqrcode {
  position: relative;
  min-height: 100vh;
  .card {
    position: relative;
    left: 5%;
    width: 90%;
    top: 15px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .cardName {
      margin: 15px 0 15px 15px;
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
    .cardNumAndState {
      .cardNum {
        margin: 0 0 15px 15px;
        float: left;
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
      }
      .noUsedStatus {
        margin-right: 15px;
        float: right;
        font-size: 1.1rem;
        font-weight: bold;
        color: #00706E;
      }
      .usedStatus {
        margin-right: 15px;
        float: right;
        font-size: 1.1rem;
        font-weight: bold;
        color: #999999;
      }
    }
    .name {
      margin: 15px 0 15px 15px;
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
  }
  .useData {
    position: relative;
    left: 5%;
    width: 90%;
    .useDataName {
      margin: 25px 0 15px 15px;
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
    .usedDate,
    .usedPerson {
      margin: 0 0 15px 15px;
      float: left;
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
    }
  }
  .tips {
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
  .btnDiv {
    position: absolute;
    bottom: 0%;
    width: 100%;
    .btn {
      width: 100%;
      font-size: 1.1rem;
      background: linear-gradient(270deg, #00706E, #00706E);
      border: none;
      padding: 10px 0;
      color: white;
    }
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/writeOff/Welfareqrcode.vue